import React from 'react';
import {Box, Tooltip, Typography} from "@mui/material";

type MessageReferenceProps = {
    referencia: string
    id: number
}

function MessageReference({ referencia, id }: MessageReferenceProps) {
    return (
        <>
          <Tooltip title={referencia}>
            <Typography noWrap variant='body2' minWidth={0}>
                <Box component='span' sx={{ fontWeight: 600, fontSize: '0.8125em' }}>
                    {'Ref.: '}
                </Box>
                {referencia}
            </Typography>
          </Tooltip>
            <Typography noWrap variant='body2' minWidth={0}>
                <Box component='span' sx={{ fontWeight: 600, fontSize: '0.8125em' }}>
                    {'Id: '}
                </Box>
                {id}
            </Typography>
        </>
    );
}

export default MessageReference;
